// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"Xaa-z"};